export enum NotificationIllustratedAlignment {
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL',
}
